import React from 'react';
const Map = () =>{
    return(<>
    <iframe className="responsive-iframe" title="ePackBook Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.215992497464!2d77.04158387518403!3d28.412738775785503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d229aba105daf%3A0xb3fa0d0a48c3dabf!2sePackBook!5e0!3m2!1sen!2sin!4v1684767160374!5m2!1sen!2sin" height={400} width={"auto"}  loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
    </>);
}
export default Map